import { useEffect, useState } from "react";
import { HOME_ROUTE, TUTOR_ACCRUALS_ROUTE } from "../../app/router/routes";
import { TutorAccruals } from "../../widgets/tutorAccruals";
import { LayoutPages } from "../layoutPages";
import classes from './tutorAccruals.module.scss'
import { useGlobalMessageActions } from "../../entities/globalMessage";
import { FEATURES, hasFeature, useMyActions } from "../../entities/my";
import { ITutorReceiptItem, ReceiptFailer, tutorService } from "../../entities/tutor";
import { MyError } from "../../shared/lib/error/MyError";
import { AuthError } from "../../shared/lib/error/AuthError";
import { useAppSelector } from "../../app/store/store";
import { Navigate } from "react-router-dom";
import { SurfaceBlock } from "../../shared/ui/surfaceBlock";

export default function TutorAccrualsPage() {

    const [pendingPayout, setPendingPayout] = useState<ITutorReceiptItem | null>(null)
    const [trigger, setTrigger] = useState<number>(0)
    const {setGlobalMessage} = useGlobalMessageActions()
    const {setIsAuth} = useMyActions()
    const {my} = useAppSelector(s => s.myReducer)
    const canReadPayouts = my.role === 'tutor' && hasFeature(my, FEATURES.TUTORS.PAYOUTS_READ, my.id)

    const checkFailer = async () => {
        try{
            const payout = await tutorService.getPendingReceipt()
            setPendingPayout(payout)
        }
        catch(e){
            console.log(e)
            if(e instanceof AuthError){
                setIsAuth(false)
                setGlobalMessage({message: e.message, type: 'error'})
            }
            else if(e instanceof MyError){
                setGlobalMessage({message: e.message, type: 'error'})
            }
            else{
                setGlobalMessage({message: 'Ошибка при получении данных о задолжности загрузки чека исполнителя', type: 'error'})
            }
        }
    }

    const onTrigger = () => {
        setTrigger(trigger + 1)
    }
    useEffect(() => {
        if(canReadPayouts){
            checkFailer()
        }
    }, [trigger, canReadPayouts])

    if(!canReadPayouts){
        return <Navigate to={HOME_ROUTE.path} replace />
    }

    return (
        <LayoutPages title={TUTOR_ACCRUALS_ROUTE.name}>
            <section className={classes.wrapper}>
                {
                    pendingPayout
                        &&
                    <ReceiptFailer />
                }
                <SurfaceBlock className={classes.payouts}>
                    <TutorAccruals
                        onTrigger={onTrigger}
                        pendingPayout={pendingPayout}
                    />
                </SurfaceBlock>
            </section>
        </LayoutPages>
    )
}
